import PasswordChange from './PasswordChange'

export default PasswordChange
